import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from '@getro/rombo';
import { Box, Flex, Text } from 'rebass/styled-components';
import { ExternalLink } from 'lucide-react';
import { getSourcingAgentFormUrl } from 'helpers/urlHelpers';
import { trackEvent } from 'helpers/analytics';
import { SourcingIllustration } from './sourcingIllustration';
import { AiGiftIcon } from './aiGiftIcon';

export const CreateCampaignModal = ({ onClose, userEmail }) => (
  <Modal isOpen onCancel={onClose}>
    <Flex
      sx={{
        flexDirection: 'column',
        gap: '40px',
        maxWidth: '432px',
        width: '100%',
        mx: 'auto',
        alignItems: 'center',
        p: '16px',
      }}
    >
      <SourcingIllustration />
      <Flex sx={{ gap: '16px', flexDirection: 'column' }}>
        <Flex sx={{ flexDirection: 'column', gap: '8px' }}>
          <Text
            sx={{
              color: 'text.dark',
              fontSize: '18px',
              fontStyle: 'normal',
              fontWeight: '600',
              lineHeight: '140%',
            }}
          >
            Create a new campaign
          </Text>
          <Text
            sx={{
              color: 'text.main',
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: '400',
              lineHeight: '140%',
            }}
          >
            During this early beta, use the form linked below to start a new campaign.
          </Text>
        </Flex>
        <Button
          variant="primary"
          size="large"
          width="100%"
          justifyContent="center"
          as="a"
          href={getSourcingAgentFormUrl({ email: userEmail })}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}
          onClick={() => {
            trackEvent('sourcing_agent:create_campaign_external_form_click');
            onClose();
          }}
        >
          Start your first campaign
          <Box as={ExternalLink} width="16px" height="16px" aria-hidden="true" />
        </Button>
      </Flex>
      <Box
        sx={{
          bg: 'white',
          border: '1px solid transparent',
          borderRadius: '4px',
          p: '16px',
          backgroundImage:
            'linear-gradient(white, white), linear-gradient(94deg, #4900FF 3.21%, #D400FF 63.82%, #FF9257 134.26%)',
          backgroundOrigin: 'border-box',
          backgroundClip: 'padding-box, border-box',
        }}
      >
        <Flex flexDirection="row" sx={{ gap: '32px' }}>
          <Text flex="1" fontSize="14px" color="text.main" lineHeight="1.4">
            Your{' '}
            <Text as="span" fontWeight="semibold">
              first 3 campaigns are free
            </Text>{' '}
            to explore what the Agent can do!
          </Text>

          <AiGiftIcon width="32px" height="32px" />
        </Flex>
      </Box>
    </Flex>
  </Modal>
);

CreateCampaignModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  userEmail: PropTypes.string.isRequired,
};

export default CreateCampaignModal;
